const GITHUB_API_KEY = "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";
const SMTP_HOST = "mail.privateemail.com";
const SMTP_PORT = "465";
const SMTP_USER = "support@glimmr.app";
const SMTP_PASSWORD = "0mOVdQtn84@NF5nn";
const SMTP_FROM = "Glimmr <support@glimmr.app>";
const LICENSE_MIN_PRICE = "1.99";
const LICENSE_MAX_PRICE = "5.99";
const STRIPE_SECRET_KEY = "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";
const STRIPE_PRODUCT_ID = "prod_RV174P8sBonywM";
export {
  GITHUB_API_KEY as G,
  LICENSE_MIN_PRICE as L,
  SMTP_FROM as S,
  LICENSE_MAX_PRICE as a,
  SMTP_USER as b,
  SMTP_HOST as c,
  SMTP_PORT as d,
  SMTP_PASSWORD as e,
  STRIPE_PRODUCT_ID as f,
  STRIPE_SECRET_KEY as g
};
